// services/aspirantUtils.js

/**
 * Filtre les aspirants par parcours.
 * @param {Array} aspirants - Liste des aspirants
 * @returns {{ chefGuide: Array, syl: Array }}
 */
export function splitAspirantsByParcours(aspirants = []) {
    const chefGuide = aspirants.filter((a) => a.parcours === "Chef Guide");
    const syl = aspirants.filter((a) => a.parcours === "Senior Youth Leader");
  
    return { chefGuide, syl };
  }

/**
 * Transforme le parcours en format d'affichage court
 * @param {string} parcours - Le parcours depuis la BDD
 * @returns {string} - Format d'affichage (MG pour Chef Guide, SYL pour Senior Youth Leader)
 */
export function formatParcours(parcours) {
  if (!parcours) return parcours;
  
  const parcoursLower = parcours.toLowerCase().trim();
  
  if (parcoursLower === "chef guide") {
    return "MG";
  } else if (parcoursLower === "senior youth leader") {
    return "SYL";
  }
  
  // Retourner le parcours tel quel si ce n'est pas un des deux cas connus
  return parcours;
}
  